// @flow
import Vue from 'vue'

/**
 * Require and code split / lazy load buttons / action components
 */
const miscCodeSplit = () => {
  // split out into misc cta chunk
  Vue.component('social-share-buttons', () =>
    import(/* webpackChunkName: "misc-ctas" */ 'app/components/buttons/social-share-buttons.vue'),
  )

  Vue.component('video-expandable-callout', () =>
    import(
      /* webpackChunkName: "misc-ctas" */ 'app/components/videos/video-expandable-callout.vue'
    ),
  )

  Vue.component('fixed-footer-cta', () =>
    import(/* webpackChunkName: "misc-ctas" */ '../components/buttons/fixed-footer-cta.vue'),
  )

  Vue.component('header-toolbar-buttons', () =>
    import(/* webpackChunkName: "misc-ctas" */ '../components/buttons/header-toolbar-buttons.vue'),
  )

  /* PLANS */
  Vue.component('plans-scheduled-instances', () =>
    import(/* webpackChunkName: "misc-ctas" */ '../components/plans/plans-scheduled-instances.vue'),
  )

  Vue.component('program-actions', () =>
    import(/* webpackChunkName: "misc-ctas" */ '../components/buttons/program-actions.vue'),
  )

  Vue.component('program-instance-delete-button', () =>
    import(
      /* webpackChunkName: "misc-ctas" */ '../components/buttons/program-instance-delete-button.vue'
    ),
  )

  /* CALENDAR */
  Vue.component('workout-calendar-ctas', () =>
    import(/* webpackChunkName: "misc-ctas" */ '../components/buttons/workout-calendar-ctas.vue'),
  )

  Vue.component('workout-complete-button', () =>
    import(/* webpackChunkName: "misc-ctas" */ '../components/buttons/workout-complete-button.vue'),
  )

  Vue.component('day-complete-button', () =>
    import(/* webpackChunkName: "misc-ctas" */ '../components/buttons/day-complete-button.vue'),
  )
}

export default miscCodeSplit
